import { normalize, denormalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import api from 'api/api';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { spaceSchema, spacesSchema } from '../../store/schema';
import {
  createSpaceSuccess,
  deleteSpaceSuccess,
  fetchAllSpacesForAllFolderTreesSuccess,
  fetchAllSpacesSuccess,
  updateSpaceSuccess,
} from './actions';
import { entitiesFetchSuccess } from '../../store/entities/actions';
import { getEntities } from '../../store/entities/selectors';


const fetchAll = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL),
  switchMap(() => api.spaces.fetchAll().pipe(
    map((response) => normalize(response.body, spacesSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllSpacesSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const fetchAllForAllFolderTrees = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL_FOR_ALL_FOLDER_TREES),
  switchMap(() => api.spaces.fetchAll().pipe(
    map((response) => normalize(response.body, spacesSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllSpacesForAllFolderTreesSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const createSpace = (action$, state$) => action$.pipe(
  ofType(actionTypes.CREATE),
  switchMap((action) =>
    api.spaces.create(denormalize(action.space, spaceSchema, getEntities(state$.value))).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, spaceSchema);
        return [
          entitiesFetchSuccess(entities),
          createSpaceSuccess(response.body),
        ];
      }),
      catchError((error) => [handleError(error)]),
    )),
);


const updateSpace = (action$, state$) => action$.pipe(
  ofType(actionTypes.UPDATE),
  switchMap((action) =>
    api.spaces.update(denormalize(action.space, spaceSchema, getEntities(state$.value))).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, spaceSchema);
        return [
          entitiesFetchSuccess(entities),
          updateSpaceSuccess(action.space.id),
        ];
      }),
      catchError((error) => [handleError(error)]),
    )),
);


const updateSpaceBody = (action$) => action$.pipe(
  ofType(actionTypes.UPDATE_BODY),
  switchMap((action) =>
    api.spaces.updateBody(action.space.id, action.space.body).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, spaceSchema);
        return [
          entitiesFetchSuccess(entities),
          updateSpaceSuccess(action.space.id),
        ];
      }),
      catchError((error) => [handleError(error)]),
    )),
);


const deleteSpace = (action$) => action$.pipe(
  ofType(actionTypes.DELETE),
  switchMap((action) => api.spaces.delete(action.space).pipe(
    mergeMap(() => [
      deleteSpaceSuccess(action.space.id),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);

export default combineEpics(
  fetchAll,
  fetchAllForAllFolderTrees,
  createSpace,
  updateSpace,
  updateSpaceBody,
  deleteSpace,
);
